import { useEffect, useState, useRef } from 'react';
import {
    FormGroup,
    FormControlLabel,
    Checkbox,
    Typography,
    Divider,
    Autocomplete,
} from '@mui/material';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { toast, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useNavigate, useLocation } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import axiosInstance from '../../../lib/axios';
import checkAndLock from '../../../GlobalFunction/checkAndLock';
import UnLock from '../../../GlobalFunction/UnLock';
import CrudButtons from '../../../GlobalFunction/CrudButtons';
import ReportTable from '../../../atoms/ReportFolder/ReportTable';
import { useReactToPrint } from 'react-to-print';
import CustomAutocomplete from '../../AutoComplete/AutoComplete';

const columns = [
    { id: 'RowNum', label: 'S.No.', minWidth: 170 },
    { id: 'ChkArticleName', label: 'Work Area', minWidth: 70 },
    { id: 'Abrv', label: 'Abbrivation', minWidth: 70 },
    { id: 'StdRate', label: 'Std Rate', minWidth: 70 },
    { id: 'DmzChrg', label: 'Damage Charge', minWidth: 70 },
    { id: 'Remark', label: 'Remark', minWidth: 70 },
];

const ArticleMaster = () => {
    const [formData, setFormData] = useState({
        ChkArticleName: '',
        ChkArtCatId: '',
        StdRate: '',
        DmzChrg: '',
        Abrv: '',
        Remark: '',
    });

    const [error, setError] = useState({
        ChkArticleName: false,
        StdRate: false,
        DmzChrg: false,
        Abrv: false,
    });

    const navigate = useNavigate();
    const location = useLocation();
    const [isFormDisabled, setIsFormDisabled] = useState(true);
    const [currentArticle, setCurrentArticle] = useState(null);
    const [artCategory, setArtCategory] = useState([]);
    const [mode, setMode] = useState('view');
    const [status, setStatus] = useState("1");
    const [lastInsertedChkArticleId, setLastInsertedChkArticleId] = useState(null);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [userId] = useState(sessionStorage.getItem('UserId'));
    const [dataForPrint, setDataForPrint] = useState({});
    const [rows, setRows] = useState([]);
    const contentRef = useRef(null);
    const handlePrint = useReactToPrint({ contentRef });
    const ChkArticleNameRef = useRef(null);
    const abrvRef = useRef(null);
    const remarkRef = useRef(null);
    const stdRateRef = useRef(null);
    const dmzChrgRef = useRef(null);

    useEffect(() => {
        if (location.state && location.state.ChkArticleId) {
            setCurrentArticle(location.state.ChkArticleId);
            fetchArticleMaster(location.state.ChkArticleId, "R");
            setMode('view');
        } else {
            setMode('add');
            setIsFormDisabled(false);
        }
    }, [location]);

    const fetchArticleMaster = async (id, flag) => {
        try {
            const response = await axiosInstance.post(`MstChkArticle/RetriveMstChkArticle`, {
                ChkArticleId: parseInt(id),
                Flag: flag,
            });

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                const workData = response.data.Data[0];
                setFormData({
                    ChkArtCatId: workData.ChkArtCatId,
                    ChkArticleName: workData.ChkArticleName || '',
                    Abrv: workData.Abrv || '',
                    StdRate: workData.StdRate || '0.00',
                    DmzChrg: workData.DmzChrg || '0.00',
                    Remark: workData.Remark || '',
                });
                setStatus(workData.status?.toString() || "1");
                setIsFormDisabled(true);
                setCurrentArticle(workData.ChkArticleId);
            } else if (response.data.Status === 1 && response.data.responseStatusCode === 2) {
                toast.info(response.data.Message);
            } else {
                toast.info(response.data.Message || 'No record Found.');
            }
        } catch (error) {
            toast.error('Error while fetching work area.');
        }
    };

    useEffect(() => {
        const getRow = async () => {
            const params = {
                start: 0,
                PageSize: 7,
                SearchText: "",
            };
            try {
                const res = await axiosInstance.post('MstChkArticle/getMstChkArticleDashBoard', { params });
                if (res.data && res.data.Data) {
                    setRows(res.data.Data);
                    setDataForPrint(res.data.Data);
                }
            } catch (err) {
                toast.error('Error fetching data:', err);
            }
        };
        getRow();
        fetchArticle();
    }, []);

    const fetchArticle = async () => {
        try {
            const response = await axiosInstance.post('MstChkArtCat/getMstChkArtCatdrp', {})
            if (response.data.Status === 0) {
                const data = response.data.Data || [];
                setArtCategory(data);
            };
        } catch (error) {
            toast.error("Error while fetching work station.");
        }
    };

    const handlePrevious = async () => {
        if (currentArticle && currentArticle > 1) {
            await fetchArticleMaster(currentArticle, "P");
        }
    };

    const handleNext = async () => {
        if (currentArticle) {
            await fetchArticleMaster(currentArticle, "N");
        }
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleChangeStatus = (event) => {
        const updatedStatus = event.target.checked ? "1" : "0";
        setStatus(updatedStatus);
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            if (event.target === ChkArticleNameRef.current) {
                abrvRef.current.focus();
            } else if (event.target === abrvRef.current) {
                remarkRef.current.focus();
            }
        }
    };

    const handleSubmit = async () => {
        let hasError = false;

        if (!formData.ChkArticleName && !formData.ChkArtCatId) {
            toast.error('Fill the required field.');
            setError((prev) => ({ ...prev, ChkArticleName: true }));
            hasError = true;
        } else {
            setError((prev) => ({ ...prev, ChkArticleName: false }));
        }

        if (hasError) return;

        try {
            const payload = {
                ChkArtCatId: formData.ChkArtCatId,
                ChkArticleName: formData.ChkArticleName,
                Abrv: formData.Abrv,
                StdRate: formData.StdRate,
                DmzChrg: formData.DmzChrg,
                Remark: formData.Remark,
                status: status,
            };

            let response;
            if (mode === 'edit') {
                payload.ChkArticleId = currentArticle;
                payload.UpdatedBy = parseInt(userId, 7);
                response = await axiosInstance.patch(`MstChkArticle/UpdateMstChkArticle`, payload);
            } else {
                payload.CreatedBy = parseInt(userId, 7);
                response = await axiosInstance.post(`MstChkArticle/InsertMstChkArticle`, payload);
            }

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                toast.success(response.data.Message);
                if (mode === 'add') {
                    setLastInsertedChkArticleId(response.data.Data);
                    await fetchArticleMaster(response.data.Data, "R");
                    setMode('view');
                    setIsFormDisabled(true);
                    setCurrentArticle(response.data.Data);
                } else {
                    setMode('view');
                    setIsFormDisabled(true);
                    await UnLock(currentArticle, "MstChkArticle", "ChkArticleId");
                }
            } else {
                toast.info(response.data.Message || 'No record found.');
            }
        } catch (error) {
            toast.error('Error while saving work area.');
        }
    };

    const handleEdit = async () => {
        let flag = await checkAndLock(currentArticle, "MstChkArticle", "ChkArticleId");
        switch (flag) {
            case 0:
                setMode("edit");
                setIsFormDisabled(false);
                break;
            case 1:
                toast.info("Record Already Locked.", { autoClose: 500 });
                break;
            case 2:
                toast.error("Record Failed To Lock.", { autoClose: 500 });
                break;
            default:
                toast.error("Something Went Wrong.", { autoClose: 500 });
        }
    };

    const handleAdd = () => {
        setMode('add');
        setIsFormDisabled(false);

        const defaultArtCatId = artCategory.length > 0 ? artCategory[0].Id : '';

        setFormData({
            ChkArtCatId: defaultArtCatId,
            ChkArticleName: '',
            Abrv: '',
            StdRate: '',
            DmzChrg: '',
            Remark: '',
        });

        setCurrentArticle(null);
        setStatus("1");

        setTimeout(() => {
            ChkArticleNameRef.current?.focus();
        }, 0);
    };

    const handleCancel = async () => {
        try {
            await fetchArticleMaster(1, "L");
            await UnLock(currentArticle, "MstChkArticle", "ChkArticleId");
            setStatus("1");
            setMode('view');
            setIsFormDisabled(true);
        } catch (error) {
            toast.error('Error occurred while cancelling. Please try again.');
        }
    };

    const handleExit = () => {
        navigate('/articletable');
    };

    const handleDeleteClick = () => {
        setOpenConfirmDialog(true);
    };

    const handleCloseConfirmDialog = () => {
        setOpenConfirmDialog(false);
    };

    const handleConfirmDelete = async () => {
        const flag = await checkAndLock(currentArticle, "MstChkArticle", "ChkArticleId");
        switch (flag) {
            case 0:
                setOpenConfirmDialog(false);
                await fetchArticleMaster(currentArticle, "D");
                await fetchArticleMaster(1, "N");
                setStatus("1");
                setMode('view');
                setIsFormDisabled(true);
                toast.success("Record deleted successfully.");
                break;
            case 1:
                toast.info("Record Already Locked", { autoClose: 500 });
                break;
            case 2:
                toast.error("Record Failed To Lock", { autoClose: 500 });
                break;
            default:
                toast.error("Something Went Wrong", { autoClose: 500 });
        }
    };

    return (
        <>
            <Box className="form-container" sx={{ height: { xs: '700px', sm: '550px' } }}>
                <ToastContainer
                    position="top-center"
                    autoClose={2000}
                    hideProgressBar={false}
                    closeOnClick={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                    transition={Slide}
                    style={{
                        position: 'fixed',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 'auto',
                        maxWidth: '400px',
                        zIndex: 9999,
                    }}
                />
                <Grid container spacing={1} className="form_grid">
                    <Grid item xs={12} className="form_title"
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            marginTop: '20px',
                            flexDirection: { xs: 'column', sm: 'row', md: 'row' },
                        }}
                    >
                        <Grid
                            sx={{
                                display: 'flex',
                                justifyContent: { xs: 'center', sm: 'flex-start' },
                                marginBottom: { xs: '7px', sm: 0 },
                            }}
                        >
                            <Button
                                variant="contained"
                                size="small"
                                className="three-d-button-previous"
                                onClick={handlePrevious}
                                sx={{ backgroundColor: '#635BFF', marginRight: { xs: '5px', sm: '7px' }, display: { xs: 'none', sm: 'block' } }}
                                disabled={mode !== 'view' || !currentArticle || currentArticle === 1}
                            >
                                <KeyboardArrowLeftIcon />
                            </Button>
                            <Button
                                variant="contained"
                                size="small"
                                className="three-d-button-next"
                                onClick={handleNext}
                                sx={{ backgroundColor: '#635BFF', display: { xs: 'none', sm: 'block' } }}
                                disabled={mode !== 'view' || !currentArticle}
                            >
                                <NavigateNextIcon />
                            </Button>
                        </Grid>

                        <Typography
                            variant="h5"
                            sx={{
                                margin: 'auto',
                                textAlign: { xs: 'center', sm: 'center' },
                                fontSize: { xs: '24px', sm: '18px', md: '24px' },
                            }}
                        >
                            Checkin Article
                            <Divider />
                        </Typography>

                        <Grid sx={{ display: 'flex', justifyContent: 'end' }}>
                            <CrudButtons
                                moduleName="Checkin Article"
                                mode={mode}
                                onAdd={handleAdd}
                                onEdit={handleEdit}
                                onView={handlePrint}
                                onDelete={handleDeleteClick}
                                onExit={handleExit}
                                onPrevious={handlePrevious}
                                onNext={handleNext}
                                readOnlyMode={isFormDisabled}
                            />
                        </Grid>
                    </Grid>

                    <Grid item xs={12} className="form_field">
                        <Grid container spacing={1} justifyContent='center'>
                            <Grid item xs={12} md={4} lg={4}>
                                <CustomAutocomplete
                                    options={artCategory}
                                    id="work-autocomplete"
                                    name="ChkArtCatId"
                                    label={<span> Article Category <span style={{ color: 'red' }}>*</span></span>}
                                    value={artCategory.find((prop) => prop.Id == formData.ChkArtCatId) || null}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    size="small"
                                    getOptionLabel={(option) => option.Name || ''}
                                />
                            </Grid>

                            <Grid item xs={12} md={4} lg={4}>
                                <TextField
                                    id="ChkArticleName"
                                    name="ChkArticleName"
                                    label={
                                        <span>
                                           Checkin Article <span style={{ color: 'red' }}>*</span>
                                        </span>
                                    }
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formData.ChkArticleName}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    error={error.ChkArticleName}
                                    helperText={error.ChkArticleName && ""}
                                    inputRef={ChkArticleNameRef}
                                    onKeyDown={handleKeyPress}
                                />
                            </Grid>

                            <Grid item xs={12} className="form_field">
                                <Grid container spacing={1} justifyContent='center'>
                                    <Grid item xs={12} md={4} lg={4}>
                                        <TextField
                                            id="Abrv"
                                            name="Abrv"
                                            label="Abbrivation/Code"
                                            variant="filled"
                                            fullWidth
                                            className="custom-textfield"
                                            value={formData.Abrv}
                                            onChange={handleInputChange}
                                            disabled={isFormDisabled}
                                            inputRef={abrvRef}
                                            onKeyDown={handleKeyPress}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={2} lg={2}>
                                        <TextField
                                            id="StdRate"
                                            name="StdRate"
                                            label="Rate"
                                            variant="filled"
                                            fullWidth
                                            className="custom-textfield"
                                            value={formData.StdRate}
                                            onChange={handleInputChange}
                                            disabled={isFormDisabled}
                                            inputRef={stdRateRef}
                                            onKeyDown={handleKeyPress}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={2} lg={2}>
                                        <TextField
                                            id="DmzChrg"
                                            name="DmzChrg"
                                            label="Damge Charge"
                                            variant="filled"
                                            fullWidth
                                            className="custom-textfield"
                                            value={formData.DmzChrg}
                                            onChange={handleInputChange}
                                            disabled={isFormDisabled}
                                            inputRef={dmzChrgRef}
                                            onKeyDown={handleKeyPress}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} className="form_field">
                        <Grid container spacing={1} justifyContent='center'>
                            <Grid item xs={12} md={5} lg={6}>
                                <TextField
                                    id="Remark"
                                    name="Remark"
                                    label="Remark"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formData.Remark}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    inputRef={remarkRef}
                                />
                            </Grid>

                            <Grid item xs={12} md={6} lg={2}>
                                <FormGroup>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                disabled={isFormDisabled}
                                                checked={status === "1"}
                                                onChange={handleChangeStatus}
                                            />
                                        }
                                        label="Status"
                                    />
                                </FormGroup>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} className="form_button">
                        {mode === 'view' && (
                            <>
                                <Button
                                    variant="contained"
                                    sx={{ mr: 1, background: 'linear-gradient(290deg, #d4d4d4, #ffffff)' }}
                                    onClick={handleAdd}
                                    disabled
                                >
                                    Submit
                                </Button>
                                <Button
                                    variant="contained"
                                    sx={{ mr: 1, background: 'linear-gradient(290deg, #a7c5e9, #ffffff)' }}
                                    onClick={handleEdit}
                                    disabled
                                >
                                    Cancel
                                </Button>
                            </>
                        )}
                        {(mode === 'edit' || mode === 'add') && (
                            <>
                                <Button variant="contained" sx={{ mr: 1 }} onClick={handleSubmit}>
                                    Submit
                                </Button>
                                <Button variant="contained" sx={{ mr: 1 }} onClick={handleCancel}>
                                    Cancel
                                </Button>
                            </>
                        )}
                    </Grid>
                </Grid>
            </Box>

            <div style={{ display: 'none' }}>
                {Object.keys(dataForPrint).length > 0 && (
                    <ReportTable
                        columns={columns}
                        rows={rows}
                        title="Article Master"
                        contentRef={contentRef}
                        customStyles={{ backgroundColor: '#f5f5f5' }}
                    />
                )}
            </div>

            <Dialog
                open={openConfirmDialog}
                onClose={handleCloseConfirmDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Confirm Deletion"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete this record?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        sx={{
                            backgroundColor: '#635bff',
                            color: 'white',
                            '&:hover': { backgroundColor: '#1565c0', color: 'white' },
                        }}
                        onClick={handleConfirmDelete}
                    >
                        Yes
                    </Button>
                    <Button
                        sx={{
                            backgroundColor: '#635bff',
                            color: 'white',
                            '&:hover': { backgroundColor: '#1565c0', color: 'white' },
                        }}
                        onClick={handleCloseConfirmDialog}
                    >
                        No
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default ArticleMaster;
